import {IPageTitleTranslation} from '../../redux/auth/interfaces';

export function getLocalizedTitle(
  title: string | undefined,
  titles: IPageTitleTranslation[] | undefined,
  locale: string
): string | undefined {
  if (locale === 'en') {
    return title;
  }

  return titles?.find((translation) => translation.lang === locale)?.value;
}
